import * as React from 'react';

const SvgChat = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.77 8.878C7.67 8.8 8.806 8.8 10.333 8.8h2.134c2.987 0 4.48 0 5.62.585a5.347 5.347 0 0 1 2.332 2.342c.581 1.147.581 2.648.581 5.65v2.895c0 .3 0 .45-.006.576a5.363 5.363 0 0 1-2.91 4.526l1.646 1.174c1.074.766 2.485-.34 1.995-1.564a1.32 1.32 0 0 1 1.227-1.81h.722c2.5 0 4.526-2.024 4.526-4.52v-5.067c0-3.356 0-5.034-.654-6.315a5.996 5.996 0 0 0-2.622-2.619C23.64 4 21.96 4 18.6 4h-2.4c-3.36 0-5.04 0-6.324.653a5.996 5.996 0 0 0-2.622 2.619c-.237.463-.388.979-.484 1.606Z'
      fill='#333'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.291 12.583c.509 1.012.509 2.336.509 4.986v2.553c0 .265 0 .397-.005.509-.114 2.436-2.037 4.386-4.441 4.5-.11.006-.256.006-.547.006h-.075a4.624 4.624 0 0 0-2.658.864l-.05.035-2.436 1.765c-.835.605-1.933-.269-1.552-1.235.27-.684-.227-1.429-.954-1.429H6.52C4.576 25.137 3 23.54 3 21.57v-4c0-2.65 0-3.974.509-4.986a4.7 4.7 0 0 1 2.039-2.067C6.546 10 7.853 10 10.467 10h1.866c2.614 0 3.92 0 4.919.516a4.7 4.7 0 0 1 2.04 2.067ZM7.8 19.6a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm4.8-1.2a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0Zm2.4 1.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z'
      fill='#333'
    />
  </svg>
);

export default SvgChat;
